module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0275.ee198329.jpg";